import { clone, remove } from 'lodash'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'
import { Button, Select, TextInput } from 'Components/Form'
import * as Yup from 'yup'

export const dataDefault = {
    material_id: '',
    bags_count: '',
}

export const materialTypesSchema = Yup.object().shape({
    material_id: Yup.string().required('The material field is required.'),
    bags_count: Yup.string().required('The bags count field is required.'),
})

export default function MaterialTypes({ index, datas, data, setFieldValue, touched, errors, materials, selectedIds = [] }) {
    const name = `material_types[${index}].`
    return (
        <div className="flex flex-col gap-3">
            <div className={`grid grid-cols-3 gap-3 sm:grid-cols-6`}>
                <Select
                    id={`${name}material_id`}
                    name={`${name}material_id`}
                    label="Material"
                    placeholder="Type"
                    value={data.material_id}
                    options={materials
                        .filter(e => !selectedIds.includes(e.id) || e.id === data.material_id)
                        .map(e => ({
                            id: e.id,
                            label: e.title,
                        }))}
                    onChange={e => setFieldValue(`${name}material_id`, e.target.value)}
                    error={touched?.material_id && errors?.material_id}
                    className="col-span-3 sm:col-span-2"
                />
                <TextInput
                    type="number"
                    id={`${name}bags_count`}
                    name={`${name}bags_count`}
                    label="Number of Bags"
                    placeholder="Number of Bags"
                    value={data.bags_count}
                    onChange={e => setFieldValue(`${name}bags_count`, e.target.value)}
                    error={touched?.bags_count && errors?.bags_count}
                    min="1"
                    className="col-span-3 sm:col-span-2"
                />
                <div className="sm:col-span-2">
                    <div className={`flex items-center gap-3 pt-7`}>
                        {index + 1 === datas.length ? (
                            <Button
                                type="button"
                                className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                onClick={() => {
                                    const saveTask = clone(datas)
                                    saveTask.push(dataDefault)
                                    setFieldValue('material_types', saveTask)
                                }}
                            >
                                <AiOutlinePlus size={20} />
                            </Button>
                        ) : null}
                        {datas.length > 1 ? (
                            <Button
                                type="button"
                                className="text-white border-danger bg-danger"
                                onClick={() => {
                                    const saveTask = clone(datas)
                                    remove(saveTask, (n, key) => key === index)
                                    setFieldValue('material_types', saveTask)
                                }}
                            >
                                <AiOutlineClose size={20} />
                            </Button>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
